/**
 * <license header>
 */

/**
 * Signature verification options for webhook requests
 */
export enum SignatureVerification {
  /** Signature verification is enabled */
  ENABLED = 'enabled',
  /** Signature verification is disabled */
  DISABLED = 'disabled',
}
